import { Image } from "@/components/ui/image";
import { HStack } from "@/components/ui/hstack";
import { Center } from "@/components/ui/center";
import { Box } from "@/components/ui/box";
import { Video } from 'expo-av';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18n from '../../assets/i18n';
import { backendSyncImage } from "../../stores/thunks";
import * as MediaSelector from './MediaSelector';
import { IconM } from './IconsV2';
import loadingImg from '../../assets/images/loading.png';
import missingImg from '../../assets/images/missing.png';
import MediaDraw from './MediaDraw';
import { Platform } from "react-native";

/*
VIDEO Object {
  "androidImplementation": "SimpleExoPlayer",
  "didJustFinish": true,
  "durationMillis": 5736,
  "isBuffering": false,
  "isLoaded": true,
  "isLooping": false,
  "isMuted": false,
  "isPlaying": false,
  "playableDurationMillis": 5736,
  "positionMillis": 5736,
  "progressUpdateIntervalMillis": 500,
  "rate": 1,
  "shouldCorrectPitch": false,
  "shouldPlay": true,
  "uri": "/data/user/0/host.exp.exponent/files/ExperienceData/%40bosconnect%2FInACoach/ina_coach/9a47cb77-17c1-425e-a4df-8b35a96b4e32.mov",
  "volume": 1,
}
*/
export default function Media(props) {
    const dispatch = useDispatch()
    const video = useRef(null);
    const [status, setStatus] = useState({});
    const [imgSrc, setImgSrc] = useState(MediaSelector.imageSrc(props.uri, props.refresh))
    const settings = useSelector((state) => state.settings)

    const changedStatus = (newStatus) => {
        // console.log('VIDEO', status.shouldPlay, status.isPlaying, status.isLooping, status.didJustFinish, status.positionMillis)
        setStatus(newStatus)
        if (!settings.autoPlay && newStatus.didJustFinish) {
            video.current.setStatusAsync({ shouldPlay: false, positionMillis: 0 })
        }
    }

    useEffect(() => {
        if (props.uri != undefined && typeof props.uri != 'number' && !props.uri.startsWith('file:///')) {
            dispatch(backendSyncImage(props.sync || '/workflow/media/' + props.uri, props.uri)).then(result => {
                if (result == null) {
                    console.log('Media missing', props.uri)
                    setImgSrc(missingImg, props.refresh)
                } else {
                    setImgSrc(MediaSelector.imageSrc(result), props.refresh)
                }
            })
        }
    }, [])

    useEffect(() => {
        if (video.current) {
            if (props.active) {
                if (settings.autoPlay) {
                    video.current.setStatusAsync({ shouldPlay: true, isLooping: true })
                }
            } else {
                video.current.pauseAsync()
            }
        }
    }, [props.active])

    useEffect(() => {
        setImgSrc(MediaSelector.imageSrc(props.uri, props.refresh))
    }, [props.uri])

    const onLoad = () => {
        // if (imgSrc != loadingImg) {
        //     console.log('Media shown', props.uri)
        // }
    }

    const onError = (evt) => {
        console.log('IMAGE ERR', props.uri, evt.nativeEvent?.error)
        setImgSrc(loadingImg, props.refresh)
    }

    const onPress = () => {
        console.log('PRESS', settings.autoPlay, status.shouldPlay, status.isPlaying, status.isLooping, status.didJustFinish, status.positionMillis)
        status.isPlaying ? video.current.pauseAsync() : video.current.playAsync()
    }

    return (
        <Center className={`bg-primary-50 ${Platform.OS == 'web' ? 'w-[390px] h-[390px]' : 'w-screen' }`}>
            {MediaSelector.isMedia(props.uri) ?
                <>
                    <Video {...props} source={imgSrc} onLoad={onLoad} onError={onError}
                        ref={video} style={{ width: props.width || props.size, height: props.size }} videoStyle={{width: '100%', height: '100%'}} useNativeControls={false} resizeMode="contain" onPlaybackStatusUpdate={status => changedStatus(status)} />
                    {props.active && <HStack space='xl' className="absolute bottom-2">
                        <Box className="mx-12 w-12 h-12 items-center justify-center rounded-full border-2 border-primary-900 bg-[#FFFFFF80]">
                            <IconM size={32} className="text-primary-900" name='fullscreen' onPress={() => video.current.presentFullscreenPlayer()} />
                        </Box>
                        <Box className="mx-12 w-12 h-12 items-center justify-center rounded-full border-2 border-primary-900 bg-[#FFFFFF80]">
                            <IconM size={32} className="text-primary-900" name={status.isPlaying ? 'pause' : 'play-arrow'} onPress={onPress} />
                        </Box>
                    </HStack>}
                </>
                :
                <>
                    <Image {...props} source={imgSrc} resizeMode={settings.imageCrop ? 'cover' : 'contain'} size='full' onLoad={onLoad} onError={onError} alt={i18n.t('global.missingImage')} />
                    {props.overlay && <MediaDraw size={props.size} overlay={props.overlay}/>}
                </>
            }
            {(props.icon && props.icon != '' || props.icon == undefined) && typeof props.uri == 'string' && props.uri.startsWith('file:///') && <IconM className="absolute top-1 right-0 ml-2 text-3xl text-ina-red" name={props.icon ? props.icon : 'sync-problem'} />}      
        </Center>
    );
}
